import { Tooltip, Typography, TypographyProps } from '@mui/material'
import { sxc } from 'components/no-ui/styles/styleTypes'
import { useEffect, useRef, useState } from 'react'

type C1TextWithLineClampProps = {
    /**
     * The maximum number of lines to display before truncating.
     */
    lineClamp: number
} & TypographyProps

/**
 * Wraps MUI `<Typography />` component, adds CSS line clamp, and a `<Tooltip />`.
 * https://caniuse.com/css-line-clamp
 */
export const C1TextWithLineClamp: React.FC<C1TextWithLineClampProps> = ({ lineClamp, children, ...props }) => {
    const [isOverflowed, setIsOverflow] = useState(false)
    const textElementRef = useRef<null | HTMLDivElement>(null)

    useEffect(() => {
        if (!textElementRef.current) {
            return
        }
        setIsOverflow(textElementRef.current.scrollHeight > textElementRef.current.clientHeight)
    }, [])

    return (
        <Tooltip
            title={children}
            disableHoverListener={!isOverflowed}
            placement="bottom"
            enterDelay={500}
        >
            <Typography
                {...props}
                ref={textElementRef}
                sx={sxc({
                    lineClamp,
                    display: '-webkit-box',
                    WebkitLineClamp: lineClamp,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                }, props.sx)}
            >
                {children}
            </Typography>
        </Tooltip>
    )
}
